// css
import "assets/css/style.css"
// pages & components
// import Home from "pages/Home";
import Dashboard from "pages/Dashboard";
import Header from "layout/Header/Header";
import Footer from "layout/Footer/Footer";
// react router
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Data Context
import DataContextProvider from "context/DataContext";

function App() {
  // console.clear();
  // console.warn = () => {};
  return (
    <BrowserRouter>
      <DataContextProvider>
        <Header />
        <Routes>
          <Route path="/" exact element={<Dashboard />} />
          <Route path="/home" exact element={<Dashboard />} />
          <Route path="/dashboard" exact element={<Dashboard />} />
        </Routes>
        <Footer />
      </DataContextProvider>
    </BrowserRouter>
  );
}

export default App;
